/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:store
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/21 | 富士通株式会社         | 新規作成
// 01.01.00 | 2023/10/10 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
//================================================================================
 */
import { createStore } from "vuex";
import createPersistedState from 'vuex-persistedstate';

import { user } from './user.js';
import { data } from './data.js';
import { message } from './message.js';
import { error } from './error.js';
import { dialog } from './dialog.js';
import { view } from './view.js';
import { env } from './env.js';
import { ajax } from './ajax.js';

const store = createStore({
	state: {
	},
	mutations: {
	},
	actions: {
	},
	modules: {
		user,
		data,
		message,
		error,
		dialog,
		view,
		env,
		ajax
	},
	// createPersistedState
	plugins: [createPersistedState(
		{ // ストレージのキー
			key: 'toeijutaku-online',

			// 管理対象のステートを指定。
			paths: [
				'view',
				'error'
			],

			// セッションストレージに保存
			storage: window.sessionStorage
		}
	)]
})

export default store